<div class="mt-1 flex-center">
  <form name="todoForm" [formGroup]="todoForm" (ngSubmit)="getTodos()" class="vertical-flex">
    <mat-form-field appearance="fill">
      <mat-label>{{ 'Global.Filter' | translate }}</mat-label>
      <mat-select [(value)]="selectedGroup" (selectionChange)="groupSelected()">
        @for (group of groupList; track group) {
          <mat-option [value]="group._id">
            {{ group.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>{{ 'Global.StartDate' | translate }}</mat-label>
      <input type="text" [placeholder]="'Courses.Event.StartDate' | translate" [matDatepicker]="startDatePicker" formControlName="startDate" matInput />
      <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>{{ 'Global.EndDate' | translate }}</mat-label>
      <input [matDatepicker]="endDatePicker" [placeholder]="'Courses.Event.EndDate' | translate" formControlName="endDate" matInput />
      <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>
    <div class="text-center">
      <div class="mt-1">
        <div>
          <button mat-flat-button class="mb-05" color="primary" (click)="addEvent()">
            {{ 'ToDo.CreateTodo' | translate }}
          </button>
        </div>

        <div class="mt-1">
          <button mat-flat-button color="primary" class="mb-05" type="submit">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </div>
      <!--       <button mat-flat-button color="primary" type="submit">{{'Global.Refresh'|translate}}</button>
      -->
    </div>
  </form>
</div>
